module.exports = __webpack_public_path__ + "static/media/icon-sales-closing-white.842690d3.svg";